@forward './common.module.scss';
@forward './components/sidebar.module.scss';
@forward './components/table.module.scss';
@forward './components/details.module.scss';
